import WeekdayOccurrence from '@/domain/termine/features/CreateTermin/Sheet/components/WeekdayOccurrence';
import WeedayOccurrenceDrawer from '@/domain/termine/features/CreateTermin/Drawer/components/WeedayOccurrenceDrawer';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { Field } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function WeekdayOccurrenceSelectFormField() {
  const { form } = useCreateTermineFormContext();
  const { t } = useTranslation();

  return (
    <form.Field name="wochentagAuftreten">
      {(field) => (
        <Field className="flex flex-col w-full gap-1">
          <label className="text-neutrals-900 text-xs font-bold">
            {t('domain.termine.sheet.fields.jedenRequired')}
          </label>
          <div className="block md:hidden">
            <WeedayOccurrenceDrawer
              value={field.state.value ?? undefined}
              onChange={field.handleChange}
            />
          </div>
          <div className="hidden md:block">
            <WeekdayOccurrence
              value={field.state.value ?? undefined}
              onChange={field.handleChange}
            />
          </div>
        </Field>
      )}
    </form.Field>
  );
}
